import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

import searchAgentAdapter from "../../../adapters/searchAgentAdapter";
import routes from "../../../constants/routes";

const PHONE_SECRET = process.env.REACT_APP_PHONE_SECRET;

export const useAgentNavigation = () => {
  const navigate = useNavigate();

  const navigateToAgentDetails = useCallback(
    (selectedAgent, searchValues) => {
      const adaptedData = searchAgentAdapter(selectedAgent);
      const phone = selectedAgent.phone || searchValues.phone;

      const queryParams = new URLSearchParams();

      if (phone) {
        const encrypted = CryptoJS.AES.encrypt(phone, PHONE_SECRET).toString();
        queryParams.append("phone", encrypted);
      }

      navigate(`${routes.agentDetails}?${queryParams.toString()}`, {
        state: {
          agentData: adaptedData,
          phone,
        },
      });
    },
    [navigate],
  );

  return { navigateToAgentDetails };
};
